{
  "borderRadius": {
    "auforumassurance": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "dealt": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "dougs": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "indy": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "jump": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "legalplace": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "legalstart": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "light": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "obat": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "phenix": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "previi": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "propulse": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "qonto": {
      "border-radius-10": "2px",
      "border-radius-20": "4px",
      "border-radius-30": "8px",
      "border-radius-40": "12px",
      "border-radius-50": "16px",
      "border-radius-60": "24px",
      "border-radius-70": "32px"
    },
    "resco": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "revital": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "shine": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "sidecare": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    },
    "superindep": {
      "border-radius-10": "4px",
      "border-radius-20": "8px",
      "border-radius-30": "12px",
      "border-radius-40": "16px",
      "border-radius-50": "24px",
      "border-radius-60": "32px",
      "border-radius-70": "48px"
    }
  }
}
